/* eslint-disable max-len */
import { EnergySavingsLeafOutlined } from "@mui/icons-material";
import InfoIconOutlined from "@mui/icons-material/InfoOutlined";
import { Badge, Box, Button, CircularProgress, Grid, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import PasswordIcon from "@mui/icons-material/Password";
import AddIcon from "@mui/icons-material/Add";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import { styled, useTheme } from "@mui/material/styles";

import React, { useEffect, useState } from "react";
import { generatePath, Link, useNavigate, useSearchParams } from "react-router-dom";

import { Result } from "ethers";
import useAuthorization from "../../contexts/useAuthorization";
import { useProfileDataCache } from "../../contexts/ProfileDataCache";
import { getContract, getMetaMaskSigner } from "../../services/contract.service";
import { useAxios } from "../../services/http.service";

import { AppRoutes, landDetailLink } from "../../config";
import ApiRoutes from "../../config/api.routes";
import { EcoTokenStatus, onVerification, TERM_UNIT } from "../../utils/constants";
import { formatValue } from "../../utils/formatValue";
import { checkTransactionConfirmationReceipt, isSecondaryMarketLocked } from "../../utils/methods";
import { resolveStandardStatus } from "../../utils/standard-status";

import { LandToken } from "../../types/LandToken";
import Profile from "./index";

import { ActionBtn, BlogStoryBlock, TableSchema, Text } from "../../components";
import { PulseCircle, Row } from "../../components/FlexComponents";
import TableComponent from "../../components/TableView/TableComponent";

import { MobileEcoBankLandsSchema } from "../../utils/table-schemas";

import moment from "moment";

import { TabsRow } from "../EcoBank/TrustWallet";
import { TableWithTabs } from "../EcoBank/UserWallet";
import { initializeBlogContent } from "../SupportCenter/BlogArticle";
import { EmptyBoxNew } from "./Guarding";
import { CircularIcon, IconContainer, InfoBody, Wrapper } from "./Portal";
import TreeClaimModalNew from "./TreeClaimModalNew";
import OfferCreationModal from "./OfferCreationModal";
import OfferCancellationModal from "./OfferCancellationModal";
import LandTransferModal from "./LandTransferModal";

type WalletInfoResponse = {
  role: any;
  organization: any;
  boughtLands: number;
  boughtLandsValue: number;
  soldLands: number;
  createdAt: string;
  name: string;
  verified: boolean;
  transactions: number;
  orgVerifications: any;
};

// Extracted components for Fast Refresh compatibility
// const TreeMintPoolCellPortfolio = ({ etNft }: { etNft: LandToken | any }) => {
//   const [mintVal, setMintVal] = useState<string>("0");

//   useEffect(() => {
//     (async () => {
//       const signer = await getMetaMaskSigner();
//       const treeContract = getContract("tree-token", signer);
//       if (treeContract) {
//         try {
//           const reward: Result = await treeContract.rewardDetails(etNft?.id);
//           const {
//             timeSinceAuction,
//             easementDuration,
//             easementGuardian,
//             guardianEligibleCount,
//             guardianEligibleReward,
//             guardianRedeemedReward,
//             guardianTotalReward,
//             easementPatron,
//             patronEligibleCount,
//             patronEligibleReward,
//             patronRedeemedReward,
//             patronTotalReward,
//             easementReferralAddress,
//             referralEligibleReward,
//             referralRedeemedReward,
//             referralTotalReward,
//             totalTreesClaimed,
//             totalTreeForEasement,
//           } = reward.toObject();

//           console.log("rewardDetails values:", {
//             timeSinceAuction: timeSinceAuction.toString(),
//             easementDuration: easementDuration.toString(),
//             easementGuardian,
//             guardianEligibleCount: guardianEligibleCount.toString(),
//             guardianEligibleReward: formatValue(guardianEligibleReward, false),
//             guardianRedeemedReward: formatValue(guardianRedeemedReward, false),
//             guardianTotalReward: formatValue(guardianTotalReward, false),
//             easementPatron,
//             patronEligibleCount: patronEligibleCount.toString(),
//             patronEligibleReward: formatValue(patronEligibleReward, false),
//             patronRedeemedReward: formatValue(patronRedeemedReward, false),
//             patronTotalReward: formatValue(patronTotalReward, false),
//             easementReferralAddress,
//             referralEligibleReward: formatValue(referralEligibleReward, false),
//             referralRedeemedReward: formatValue(referralRedeemedReward, false),
//             referralTotalReward: formatValue(referralTotalReward, false),
//             totalTreesClaimed: totalTreesClaimed.toString(),
//             totalTreeForEasement: totalTreeForEasement.toString(),
//           });
//           const totalReward = formatValue(guardianEligibleReward + referralEligibleReward, false);
//           setMintVal(formatValue(totalReward ?? 0, true));
//         } catch (e) {
//           console.error("rewardDetails failed:", e);
//         }
//       }
//     })();
//   }, [etNft]);

//   return (
//     <Text numeric contrast medium>
//       {mintVal ?? 0}
//       <CurrencyLabel />
//     </Text>
//   );
// };

// const TreeMintPoolCell = ({ etNft }: { etNft: LandToken | any }) => {
//   const [mintVal, setMintVal] = useState<string>("0");

//   useEffect(() => {
//     (async () => {
//       const signer = await getMetaMaskSigner();
//       const treeContract = getContract("tree-token", signer);
//       if (treeContract) {
//         const reward: Result = await treeContract.rewardDetails(etNft?.id);
//         const {
//           timeSinceAuction,
//           easementDuration,
//           easementGuardian,
//           guardianEligibleCount,
//           guardianEligibleReward,
//           guardianRedeemedReward,
//           guardianTotalReward,
//           easementPatron,
//           patronEligibleCount,
//           patronEligibleReward,
//           patronRedeemedReward,
//           patronTotalReward,
//           easementReferralAddress,
//           referralEligibleReward,
//           referralRedeemedReward,
//           referralTotalReward,
//           totalTreesClaimed,
//           totalTreeForEasement,
//         } = reward.toObject();

//         console.log("rewardDetails values:", {
//           timeSinceAuction: timeSinceAuction.toString(),
//           easementDuration: easementDuration.toString(),
//           easementGuardian,
//           guardianEligibleCount: guardianEligibleCount.toString(),
//           guardianEligibleReward: formatValue(guardianEligibleReward, false),
//           guardianRedeemedReward: formatValue(guardianRedeemedReward, false),
//           guardianTotalReward: formatValue(guardianTotalReward, false),
//           easementPatron,
//           patronEligibleCount: patronEligibleCount.toString(),
//           patronEligibleReward: formatValue(patronEligibleReward, false),
//           patronRedeemedReward: formatValue(patronRedeemedReward, false),
//           patronTotalReward: formatValue(patronTotalReward, false),
//           easementReferralAddress,
//           referralEligibleReward: formatValue(referralEligibleReward, false),
//           referralRedeemedReward: formatValue(referralRedeemedReward, false),
//           referralTotalReward: formatValue(referralTotalReward, false),
//           totalTreesClaimed: totalTreesClaimed.toString(),
//           totalTreeForEasement: totalTreeForEasement.toString(),
//         });
//         const totalReward = formatValue(patronEligibleReward, false);
//         setMintVal(formatValue(totalReward ?? 0, true));
//       }
//     })();
//   }, [etNft]);

//   return (
//     <Text numeric contrast medium>
//       {mintVal ?? 0}
//       <CurrencyLabel />
//     </Text>
//   );
// };

// const FundsCell = ({ etNft, library }: { etNft: LandToken | any; library?: any }) => {
//   const [fundVal, setFundVal] = useState<string>("0");

//   useEffect(() => {
//     (async () => {
//       const signer = await getMetaMaskSigner();
//       const Contract = getContract("ecofutures-bank", signer);
//       if (Contract && etNft?.id !== null && etNft?.id !== undefined) {
//         try {
//           const reward: Result = await Contract.easementFundDetails(etNft?.id);
//           console.log({ reward });
//           setFundVal(formatValue(reward.toObject().totalRemainingFund, true));
//         } catch (error: any) {
//           console.error("Error calling easementFundDetails:", error);
//           if (error?.message?.includes("Easement not sold yet")) {
//             setFundVal("0");
//           } else {
//             setFundVal("N/A");
//           }
//         }
//       } else {
//         setFundVal("0");
//       }
//     })();
//   }, [etNft, library]);

//   return (
//     <Text numeric contrast medium>
//       {fundVal} {fundVal !== "N/A" && <CurrencyLabel currency="USD" />}
//     </Text>
//   );
// };

const StatusCell = ({
  etNft,
  status,
  meta,
  trust,
  library,
}: {
  etNft: LandToken | any;
  status: string;
  meta?: any;
  trust?: any;
  library?: any;
}) => {
  const standardized = resolveStandardStatus(
    { status: status as EcoTokenStatus, etNft, meta },
    { role: "guardian", hasTrust: !!trust, approvedLabel: "Approved" }
  );
  if (standardized) {
    return (
      <Text numeric capital contrast sx={{ color: standardized.color }}>
        {standardized.showPulse && (
          <PulseCircle
            warning={!!standardized.pulseWarning}
            sold={!!standardized.pulseSold && !standardized.pulseWarning}
          />
        )}
        {standardized.label}
      </Text>
    );
  }

  const [fundVal, setFundVal] = useState<string>("0");

  useEffect(() => {
    (async () => {
      const signer = await getMetaMaskSigner();
      const treeContract = getContract("tree-token", signer);
      if (treeContract && etNft?.id !== null && etNft?.id !== undefined) {
        try {
          const reward: Result = await treeContract.rewardDetails(etNft.id);
          const { guardianEligibleReward } = reward.toObject();
          const val = formatValue(guardianEligibleReward, true, 3);
          setFundVal(String(val));
        } catch (error: any) {
          if (error?.message?.includes("Tree: No reward has been set")) {
            setFundVal("0");
          } else {
            console.error("Error calling rewardDetails:", error);
            setFundVal("N/A");
          }
        }
      } else {
        setFundVal("0");
      }
    })();
  }, [etNft, library]);

  let text = "Verification";
  let color = "primary.main";
  let pulseSuccess = false;
  let pulseWarning = false;
  let showPulse = false;
  const isVerification = onVerification(status as EcoTokenStatus);
  // || status === EcoTokenStatus.VERIFICATION_REQUIRED;
  if (status === EcoTokenStatus.RE_VERIFICATION_REQUIRED) {
    text = "Unverified";
    color = "warning.main";
    showPulse = true;
    pulseWarning = true;
  } else if (etNft?.easementActivated && etNft.easementActivated.active) {
    const start = moment(etNft?.easementActivated.contractStart);
    const duration = meta?.contractPeriod || 3;
    if (start.add(duration, "days").isAfter(moment())) {
      pulseSuccess = true;
      showPulse = true;
      text = "Active";
      color = "action.pulse";
    } else {
      showPulse = false;
      const total = formatValue(etNft.easementActivated.treeTotal, false);
      const claimed = formatValue(etNft.easementActivated.rewardClaimed, false);
      text = total && total - claimed > 0 ? "Mint Available" : "Expired";
      if (text === "Expired") {
        color = "primary.main";
        showPulse = false;
      } else if (text === "Mint Available" && fundVal === "0") {
        text = "Active";
        color = "action.pulse";
        pulseSuccess = true;
        showPulse = true;
      } else {
        color = "action.pulse";
        pulseSuccess = true;
        showPulse = true;
      }
    }
  } else if (status === EcoTokenStatus.DRAFT && !!trust) {
    text = "Rejected";
    color = "warning.main";
    showPulse = true;
    pulseWarning = true;
  } else if (status === EcoTokenStatus.VERIFICATION_REQUIRED) {
    text = "Uploaded";
    color = "primary.main";
  } else if (status === EcoTokenStatus.DRAFT) {
    text = "Draft";
    color = "primary.main";
  } else if (isVerification) {
    showPulse = false;
    pulseWarning = false;
    text = "Verification";
    color = "primary.main";
  } else if (status === EcoTokenStatus.CLAIMED || status === EcoTokenStatus.VERIFICATION_REQUIRED) {
    showPulse = true;
    pulseWarning = false;
    text = "Claimed";
    color = "action.pulse";
  } else if (etNft?.id !== null && etNft?.id !== undefined && etNft?.status === "auction") {
    showPulse = true;
    pulseWarning = false;
    text = "Live auction";
    color = "action.pulse";
  } else if (status === EcoTokenStatus.VERIFIED) {
    text = "Verified";
    color = "primary.main";
  } else if (status === EcoTokenStatus.APPROVED) {
    text = "Approved";
    color = "primary.main";
  } else if (etNft?.id !== undefined && etNft?.id !== null && etNft?.status === EcoTokenStatus.VERIFIED) {
    text = "Verified";
    color = "primary.main";
  }

  return (
    <Text numeric capital contrast sx={{ color }}>
      {showPulse && <PulseCircle warning={pulseWarning} sold={pulseSuccess && !pulseWarning} />}
      {text}
    </Text>
  );
};

const StatusCellPort = ({
  etNft,
  status,
  meta,
  offerStatus,
  library,
}: {
  etNft: LandToken | any;
  status: string;
  meta?: any;
  offerStatus?: any;
  library?: any;
}) => {
  const standardized = resolveStandardStatus(
    { status: status as EcoTokenStatus, etNft, meta, offerStatus },
    { role: "public" }
  );
  if (standardized) {
    return (
      <Text numeric capital contrast sx={{ color: standardized.color }}>
        {standardized.showPulse && (
          <PulseCircle
            warning={!!standardized.pulseWarning}
            sold={!!standardized.pulseSold && !standardized.pulseWarning}
          />
        )}
        {standardized.label}
      </Text>
    );
  }

  const [fundVal, setFundVal] = useState<string>("0");
  console.log({ offerStatus });
  useEffect(() => {
    (async () => {
      const signer = await getMetaMaskSigner();
      const treeContract = getContract("tree-token", signer);
      if (treeContract && etNft?.id !== null && etNft?.id !== undefined) {
        try {
          const reward: Result = await treeContract.rewardDetails(etNft.id);
          const { patronEligibleReward } = reward.toObject();
          const val = formatValue(patronEligibleReward, true, 3);
          setFundVal(String(val));
        } catch (error: any) {
          if (error?.message?.includes("Tree: No reward has been set")) {
            setFundVal("0");
          } else {
            console.error("Error calling rewardDetails:", error);
            setFundVal("N/A");
          }
        }
      } else {
        setFundVal("0");
      }
    })();
  }, [etNft, library]);

  let text = "Verification";
  let color = "primary.main";
  let pulseSuccess = false;
  let pulseWarning = false;
  let showPulse = false;
  const isVerification = onVerification(status as EcoTokenStatus) || status === EcoTokenStatus.VERIFICATION_REQUIRED;
  const claimed = status === EcoTokenStatus.CLAIMED;
  const isOffer = offerStatus === "opened";
  if (isOffer) {
    showPulse = true;
    pulseWarning = false;
    text = "Live Offer";
    color = "action.pulse";
  } else if (status === EcoTokenStatus.RE_VERIFICATION_REQUIRED) {
    text = "Unverified";
    color = "warning.main";
    showPulse = true;
    pulseWarning = true;
  } else if (etNft?.easementActivated && etNft.easementActivated.active) {
    const start = moment(etNft?.easementActivated.contractStart);
    const duration = meta?.contractPeriod || 3;
    if (start.add(duration, "days").isAfter(moment())) {
      pulseSuccess = true;
      showPulse = true;
      text = "Active";
      color = "action.pulse";
    } else {
      showPulse = false;
      const total = formatValue(etNft.easementActivated.treeTotal, false);
      const claimed = formatValue(etNft.easementActivated.rewardClaimed, false);
      text = total && total - claimed > 0 ? "Mint Available" : "Expired";
      if (text === "Mint Available" && fundVal === "0") {
        text = "Active";
        color = "action.pulse";
        pulseSuccess = true;
        showPulse = true;
      } else if (text === "Expired") {
        color = "primary.main";
        showPulse = false;
      } else {
        color = "action.pulse";
        pulseSuccess = true;
        showPulse = true;
      }
    }
  } else if (claimed) {
    showPulse = true;
    pulseWarning = false;
    text = "Claimed";
    color = "action.pulse";
  } else if (isVerification) {
    text = "Verification";
    color = "primary.main";
  } else if (status === EcoTokenStatus.APPROVED) {
    text = "Verified";
    color = "primary.main";
  } else if (status === EcoTokenStatus.VERIFICATION_FAILED) {
    text = "Rejected";
    color = "warning.main";
  } else if (etNft?.id !== undefined && etNft?.id !== null && etNft?.status === EcoTokenStatus.VERIFIED) {
    text = "Verified";
    color = "primary.main";
  } else if (etNft?.id !== null && etNft?.id !== undefined && etNft?.status === "auction") {
    showPulse = true;
    pulseWarning = false;
    text = "Live auction";
    color = "action.pulse";
  }

  return (
    <Text numeric capital contrast sx={{ color }}>
      {showPulse && <PulseCircle warning={pulseWarning} sold={pulseSuccess && !pulseWarning} />}
      {text}
    </Text>
  );
};

// Memoized versions for performance
const MemoizedStatusCell = React.memo(
  StatusCell,
  (prevProps, nextProps) =>
    prevProps.status === nextProps.status &&
    prevProps.etNft === nextProps.etNft &&
    prevProps.meta === nextProps.meta &&
    prevProps.trust === nextProps.trust
);

const MemoizedStatusCellPort = React.memo(
  StatusCellPort,
  (prevProps, nextProps) =>
    prevProps.status === nextProps.status &&
    prevProps.etNft === nextProps.etNft &&
    prevProps.meta === nextProps.meta &&
    prevProps.offerStatus === nextProps.offerStatus
);

// Exportable factory function to create portfolio guardian status column
export const createPortfolioGuardianStatusCol = (library: any): TableSchema<LandToken> => ({
  id: "guardianStatus",
  label: "Status",
  render: ({ status, etNft, meta, offerStatus }: LandToken) => (
    <MemoizedStatusCellPort etNft={etNft} status={status} meta={meta} offerStatus={offerStatus} library={library} />
  ),
});

// Exportable factory function to create assets guardian status column
export const createAssetsGuardianStatusCol = (library: any): TableSchema<LandToken> => ({
  id: "guardianStatus",
  label: "Status",
  render: ({ status, etNft, meta, trust }: LandToken) => (
    <MemoizedStatusCell etNft={etNft} status={status} meta={meta} trust={trust} library={library} />
  ),
});

const GuardianPortal = () => {
  const navigator = useNavigate();
  const axios = useAxios();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(560));
  const { user, fetchUser, isGuardian, isPioneer } = useAuthorization();
  const { profileCache, getCachedData, refreshProfileData } = useProfileDataCache();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tokenList, setTokens] = useState<any>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [userLoading, setUserLoading] = useState<boolean>(true);
  const [landsBought, setLandsBought] = useState(0);
  ``;
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedPortfolioId, setSelectedPortfolioId] = useState<number | null>(null);
  const [selectedData, setSelectedData] = useState<any | null>(null);
  const [activeTab, setActiveTab] = useState<"lands" | "portfolio">("portfolio");
  const [cancelOfferModalOpen, setCancelOfferModalOpen] = useState(false);
  const [selectedCancelToken, setSelectedCancelToken] = useState<LandToken | null>(null);
  const [blogArticles, setBlogArticles] = useState<{ [key: string]: any }>({});
  const [blogLoading, setBlogLoading] = useState(true);
  const [actionPendingAssets, setActionPendingAssets] = useState(0);
  const [actionPendingPortfolio, setActionPendingPortfolio] = useState(0);
  const [offerCreationModalOpen, setOfferCreationModalOpen] = useState(false);
  const [selectedOfferToken, setSelectedOfferToken] = useState<LandToken | null>(null);
  const [isTransferring, setIsTransferring] = useState(false);
  const [transferError, setTransferError] = useState("");
  const [transferLoading, setTransferLoading] = useState(false);
  const [selectedTransferLand, setSelectedTransferLand] = useState<LandToken | null>(null);
  useEffect(() => {
    // Check for activeTab URL parameter
    const activeTabParam = searchParams.get("activeTab");

    if (activeTabParam && (activeTabParam === "lands" || activeTabParam === "portfolio")) {
      setActiveTab(activeTabParam);

      // Remove the URL parameter after setting the tab
      searchParams.delete("activeTab");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const loadBlogContent = async () => {
    try {
      setBlogLoading(true);
      const content = await initializeBlogContent();
      setBlogArticles(content);
    } catch (error) {
      console.error("Failed to load blog content:", error);
    } finally {
      setBlogLoading(false);
    }
  };

  const [isLoading, setIsLoading] = useState(true);
  const [tokensLoading, setPortfolioTokensLoading] = useState(true);
  const [tokens, setPortfolioTokens] = useState<number>(0);
  useEffect(() => {
    loadBlogContent();
  }, []);

  useEffect(() => {
    if (!userLoading && user) {
      // Wait for ProfileDataCache to finish loading before fetching data
      if (profileCache.isLoading) {
        console.log("GuardianPortal: Cache is loading for portfolio tokens, waiting...");
        return;
      }

      // Check if we already have cached data
      const cachedProfileTokens = getCachedData("profileTokens");
      if (!cachedProfileTokens) {
        console.log("GuardianPortal: No cached profile tokens, fetching...");
        fetchPortfolioTokens();
      } else {
        console.log("GuardianPortal: Using cached profile tokens for portfolio without fetch");
        setPortfolioTokens(cachedProfileTokens.length);
        updateActionPendingAssets(cachedProfileTokens);
        setPortfolioTokensLoading(false);
        setIsLoading(false);
      }
    }
  }, [userLoading, user, profileCache.isLoading]);

  const fetchPortfolioTokens = async () => {
    setPortfolioTokensLoading(true);
    try {
      // Try to get cached data first
      const cachedProfileTokens = getCachedData("profileTokens");

      if (cachedProfileTokens && Array.isArray(cachedProfileTokens)) {
        console.log("GuardianPortal: Using cached profile tokens", { cachedProfileTokens });
        setPortfolioTokens(cachedProfileTokens.length);

        // Process rewards using cached data - no API call needed
        updateActionPendingAssets(cachedProfileTokens);

        setPortfolioTokensLoading(false);
        setIsLoading(false);
        return;
      }

      // Fallback to API call if no cached data
      console.log("GuardianPortal: No cached profile tokens, fetching from API");
      const response = await axios.get(ApiRoutes.user.profile.tokens.root + "?total=true").then((res) => res.data);
      setPortfolioTokens(response);
      console.log({ response });
      const assetTokens: LandToken[] = await axios.get(ApiRoutes.user.profile.tokens.root).then((res) => res.data);
      console.log({ assetTokens });

      updateActionPendingAssets(assetTokens);
    } catch (e: any) {
      console.log({ e });
    } finally {
      setPortfolioTokensLoading(false);
      setIsLoading(false);
    }
  };

  // Process each token to check for rewards and count pending actions
  const processTokenRewards = async (assetTokens: LandToken[]) => {
    try {
      const signer = await getMetaMaskSigner();

      // Process all tokens in parallel to avoid await-in-loop issue
      const rewardPromises = assetTokens.map(async (token) => {
        try {
          const etNft = token.etNft;
          const treeContract = getContract("tree-token", signer);

          if (treeContract && etNft?.id !== null && etNft?.id !== undefined) {
            try {
              const reward: Result = await treeContract.rewardDetails(etNft.id);
              const { guardianEligibleReward } = reward.toObject();
              const val = formatValue(guardianEligibleReward, true, 3);
              return val !== "0" ? 1 : 0;
            } catch (error: any) {
              if (!error?.message?.includes("Tree: No reward has been set")) {
                console.error("Error calling rewardDetails:", error);
              }
              return 0;
            }
          }
          return 0;
        } catch (error) {
          console.error("Error processing token:", error);
          return 0;
        }
      });
      const rewardResults = await Promise.all(rewardPromises);
      const rewardCount = rewardResults.reduce((sum: number, count: number) => sum + count, 0);

      return rewardCount;
    } catch (error) {
      console.error("Error getting MetaMask signer:", error);
      return 0;
    }
  };

  const countPendingTokens = (assetTokens: LandToken[]) => {
    // Count tokens requiring action
    const pendingTokens = assetTokens.filter(
      (token) => token.status === EcoTokenStatus.VERIFICATION_FAILED || !token.etNft?.easementActivated
    );
    const pendingTokensCount = pendingTokens.length;
    console.log({ pendingTokensCount: pendingTokens.length });
    return pendingTokensCount;
  };

  const updateActionPendingAssets = async (assetTokens: LandToken[]) => {
    const pendingCount = countPendingTokens(assetTokens);
    const rewardCount = await processTokenRewards(assetTokens);
    const totalCount = pendingCount + rewardCount;
    setActionPendingAssets(totalCount);
    console.log({ pendingCount, rewardCount, totalCount });
  };

  const emailVerified = user?.emailVerified;
  // Upload is a Pioneer/Guardian capability. Not referrerAddress on its own: trust, trustee and
  // trust-admin invites set it too (to the inviter's wallet), so it doesn't mean "redeemed a
  // guardian invite code".
  const canMint = isGuardian || isPioneer;
  const link = emailVerified
    ? canMint
      ? AppRoutes.Upload.path
      : AppRoutes.Profile.subRoutes.Identification.path
    : AppRoutes.Profile.subRoutes.Identification.path;
  const text = emailVerified
    ? canMint
      ? "Upload your land today."
      : "Enter referral code"
    : "Complete email verification";

  useEffect(() => {
    if (!userLoading && user) {
      // Wait for ProfileDataCache to finish loading before fetching data
      if (profileCache.isLoading) {
        console.log("GuardianPortal: Cache is loading, waiting...");
        return;
      }

      // Check if we already have the data we need
      const cachedProfileTokens = getCachedData("profileTokens");
      const cachedMintedTokens = getCachedData("mintedTokens");
      const cachedBoughtLands = getCachedData("boughtLands");
      const cachedWalletData = getCachedData("walletData");

      // Only call fetch functions if we don't have the required cached data
      if (!cachedProfileTokens) {
        console.log("GuardianPortal: Missing profile tokens cache, fetching...");
        fetchPortfolioTokens();
      } else {
        console.log("GuardianPortal: Using cached profile tokens without fetch");
        setPortfolioTokens(cachedProfileTokens.length);
        updateActionPendingAssets(cachedProfileTokens);
        setPortfolioTokensLoading(false);
        setIsLoading(false);
      }

      if (!cachedMintedTokens || !cachedWalletData) {
        console.log("GuardianPortal: Missing minted tokens or wallet cache, fetching...");
        fetchTokens();
      } else {
        console.log("GuardianPortal: Using cached minted tokens without fetch");
        setTokens(Array.isArray(cachedMintedTokens) ? cachedMintedTokens.length : cachedMintedTokens);
        if (cachedWalletData.boughtLands) {
          setLandsBought(cachedWalletData.boughtLands);
        }
        setLoading(false);
      }

      if (!cachedBoughtLands) {
        console.log("GuardianPortal: Missing bought lands cache, fetching...");
        fetchBoughtLands();
      } else {
        console.log("GuardianPortal: Using cached bought lands without fetch");
        processBoughtLandsRewards(cachedBoughtLands);
        setLoading(false);
      }
    }
  }, [userLoading, user, profileCache.isLoading]);

  useEffect(() => {
    const loadUser = async () => {
      try {
        setUserLoading(true);
        await fetchUser();
      } catch (error) {
        console.error("Failed to load user:", error);
      } finally {
        setUserLoading(false);
      }
    };

    if (!user) {
      loadUser();
    } else {
      setUserLoading(false);
    }
  }, [user, fetchUser]);

  const userAddress = user?.address;

  const fetchBoughtLands = async () => {
    setLoading(true);
    setActionPendingPortfolio(0); // Reset badge count when fetching new data
    try {
      // Try to get cached data first
      const cachedBoughtLands = getCachedData("boughtLands");

      if (cachedBoughtLands && Array.isArray(cachedBoughtLands)) {
        console.log("GuardianPortal: Using cached bought lands data", { cachedBoughtLands });
        processBoughtLandsRewards(cachedBoughtLands);
        setLoading(false);
        return;
      }

      // Fallback to API call if no cached data
      const response = await axios.get(ApiRoutes.token.list + `?boughtBy=${userAddress}`).then((res) => res.data);
      console.log({ response });

      processBoughtLandsRewards(response);
    } catch (e: any) {
      console.log({ e });
      setActionPendingPortfolio(0); // Reset badge count on error
    } finally {
      setLoading(false);
    }
  };

  // Process each bought land token to check for rewards and count pending actions for portfolio
  const processBoughtLandsRewards = async (response: any[]) => {
    try {
      const signer = await getMetaMaskSigner();

      // Process all bought land tokens in parallel to avoid await-in-loop issue
      const rewardPromises = response.map(async (token: any) => {
        try {
          const etNft = token.etNft;
          const treeContract = getContract("tree-token", signer);

          if (treeContract && etNft?.id !== null && etNft?.id !== undefined) {
            try {
              const reward: Result = await treeContract.rewardDetails(etNft.id);
              const { patronEligibleReward } = reward.toObject();
              const val = formatValue(patronEligibleReward, true, 3);
              return val !== "0" ? 1 : 0;
            } catch (error: any) {
              if (!error?.message?.includes("Tree: No reward has been set")) {
                console.error("Error calling rewardDetails:", error);
              }
              return 0;
            }
          }
          return 0;
        } catch (error) {
          console.error("Error processing bought land token:", error);
          return 0;
        }
      });

      const rewardResults = await Promise.all(rewardPromises);
      const rewardCount = rewardResults.reduce((sum: number, count: number) => sum + count, 0);

      // Update the pending portfolio assets count with both pending tokens and reward count
      setActionPendingPortfolio(rewardCount);
      console.log({ portfolioRewardCount: rewardCount });
    } catch (error) {
      console.error("Error getting MetaMask signer for bought lands:", error);
      setActionPendingPortfolio(0);
    }
  };

  const fetchTokens = async () => {
    setLoading(true);
    try {
      // Try to get cached data first
      const cachedMintedTokens = getCachedData("mintedTokens");
      const cachedWalletData = getCachedData("walletData");

      if (cachedMintedTokens && cachedWalletData) {
        console.log("GuardianPortal: Using cached minted tokens and wallet data", {
          cachedMintedTokens,
          cachedWalletData,
        });

        if (cachedWalletData.boughtLands) {
          setLandsBought(cachedWalletData.boughtLands);
        }
        setTokens(Array.isArray(cachedMintedTokens) ? cachedMintedTokens.length : cachedMintedTokens);
        setLoading(false);
        return;
      }

      // Fallback to API calls if no cached data
      const response = await axios.get(ApiRoutes.token.minted(userAddress)).then((res) => res.data);
      console.log({ response });
      const wallet: WalletInfoResponse = await axios
        .get(ApiRoutes.user.wallet + `?address=${userAddress}`)
        .then((res) => res.data);
      if (wallet.boughtLands) {
        setLandsBought(wallet.boughtLands);
      }
      setTokens(response.length);
      if (!response) {
        setLoading(false);
      }
    } catch (e: any) {
      console.log({ e });
    } finally {
      setLoading(false);
    }
  };

  const handleTransferClick = (data: LandToken) => {
    setTransferError("");
    setIsTransferring(true);
    setSelectedTransferLand(data);
  };

  const handleListingSuccess = () => {
    // Backend needs a moment to index the on-chain openNFTForOffers event
    // before the new offerStatus is reflected in /token/list?boughtBy=...
    setTimeout(() => {
      refreshProfileData();
      setSelectedOfferToken(null);
      setOfferCreationModalOpen(false);
    }, 3000);
  };
  // After a TR3 claim. Silent, so neither table swaps to skeletons and the Mintable cell can
  // flip to the new figure in place. The backend indexes RewardRedeemed off a queue a few
  // seconds after the receipt, hence the same wait as the listing handlers.
  const handleClaimRefresh = () => {
    setTimeout(() => {
      refreshProfileData({ silent: true });
    }, 3000);
  };
  const handleListingCancelSuccess = () => {
    // Backend needs a moment to index the on-chain openNFTForOffers event
    // before the new offerStatus is reflected in /token/list?boughtBy=...
    setTimeout(() => {
      refreshProfileData();
      setSelectedOfferToken(null);
      setCancelOfferModalOpen(false);
    }, 3000);
  };

  const handleTransferConfirm = async (newGuardianAddress: string) => {
    setTransferError("");
    setTransferLoading(true);

    try {
      if (!selectedTransferLand) {
        throw new Error("Unexpected error, please close modal and select land again");
      }

      const signer = await getMetaMaskSigner();
      const adminContract = getContract("ecofutures-admin", signer);
      const tokenId = Number(selectedTransferLand.etNft?.id);

      if (adminContract && tokenId !== null && tokenId !== undefined) {
        const result = await adminContract.requestGuardianUpdate(tokenId, newGuardianAddress);
        const r = await checkTransactionConfirmationReceipt(result.hash);
        console.log({ r });
        const receipt = r as any;
        if (receipt?.status !== 0) {
          console.log("Guardian update requested");
          setTimeout(() => {
            refreshProfileData();
          }, 3000);
        } else {
          throw new Error("Transaction failed");
        }
      } else {
        throw new Error("Contract not found or token ID is invalid");
      }
    } catch (e: any) {
      console.log({ e });
      setTransferError(e.message || e.response?.data?.message || "Unexpected error, please try again later");
    } finally {
      setIsTransferring(false);
      setSelectedTransferLand(null);
      setTransferLoading(false);
    }
  };

  const handleTransferModalClose = () => {
    if (!transferLoading) {
      setIsTransferring(false);
      setSelectedTransferLand(null);
    } else {
      setTransferError("You cannot close this modal while transfer request is pending!");
    }
  };

  const actionSchema: TableSchema<LandToken> = {
    id: "actions",
    label: "Actions",
    render: (data) => {
      // Check if the land is expired
      const contractStart = data.etNft?.easementActivated?.contractStart;
      const contractPeriod = data.meta?.contractPeriod;
      const isExpired = contractStart && moment(contractStart).add(contractPeriod, TERM_UNIT).isBefore(moment());
      const detailsPath = landDetailLink(data.id);

      // Check if there are remaining trees for expired lands
      const total = formatValue(data.etNft?.totalTreeForEasement as any, false);
      const claimed = formatValue(data.etNft?.easementActivated?.rewardClaimed as any, false) || 0;
      const remainingTrees = total - claimed;

      // If expired and no remaining trees, show only Details button
      if (isExpired && remainingTrees <= 0) {
        return (
          <Row sx={{ gap: 3, alignItems: "center" }}>
            {/* `display: flex` makes the anchor hug the button; without `textDecoration` the
                button, now a block-level flex item rather than an inline-block, inherits the
                anchor's underline. */}
            <Link
              to={detailsPath}
              state={{ ref: AppRoutes.Profile.subRoutes.Guarding.path, mode: "mint" }}
              style={{ display: "flex", textDecoration: "none" }}
            >
              <TableActionButton size="small" color="primary" variant="contained" sx={{ textTransform: "none" }}>
                Details
              </TableActionButton>
            </Link>
          </Row>
        );
      }

      return (
        <Row sx={{ gap: 3, alignItems: "center" }}>
          {data?.offerStatus === "opened" ? (
            <TableActionButton
              size="small"
              color="primary"
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={() => {
                setSelectedCancelToken(data);
                setCancelOfferModalOpen(true);
              }}
            >
              Cancel listing
            </TableActionButton>
          ) : (
            <>
              {/* Secondary listings revert on-chain until the primary sale has settled
                  (guide §5) — isSecondaryMarketLocked also keeps pre-V9 NFTs, whose flag is
                  false by default and never backfilled, out of the block. The span keeps the
                  tooltip working over a disabled button. */}
              <Tooltip
                title={
                  isSecondaryMarketLocked(data.etNft)
                    ? "Listing opens once the primary sale has settled"
                    : "List to Offer"
                }
              >
                <span>
                  <TableActionButton
                    size="small"
                    color="primary"
                    variant="contained"
                    disabled={isSecondaryMarketLocked(data.etNft)}
                    sx={{ textTransform: "none" }}
                    onClick={() => {
                      setSelectedOfferToken(data);
                      setOfferCreationModalOpen(true);
                    }}
                  >
                    Offer
                  </TableActionButton>
                </span>
              </Tooltip>
              <Tooltip title="$TREE claiming info">
                <TableActionButton
                  disabled={selectedId !== null && selectedId !== undefined}
                  size="small"
                  variant="contained"
                  sx={tableActionIconSx}
                  onClick={() => {
                    setSelectedId(data.etNft?.id as number);
                    setSelectedData({
                      name: data.meta?.name,
                      meta: data.meta,
                      etNft: data.etNft,
                      content: data.content,
                      ecoScore: data.ecoScore,
                      targetDate: moment(data?.etNft?.easementActivated?.contractStart)
                        .add(data.meta?.contractPeriod, TERM_UNIT)
                        .toDate(),
                    });
                  }}
                >
                  <EnergySavingsLeafOutlined />
                </TableActionButton>
              </Tooltip>
            </>
          )}
        </Row>
      );
    },
  };

  // const { library } = useMetaMask();

  // const memoizedTreeMintPoolColsPortfolio = useMemo<TableSchema<LandToken>>(
  //   () => ({
  //     id: "eftMintPool",
  //     label: "Mint capacity",
  //     sx: { width: "auto", minWidth: "fit-content", maxWidth: "max-content" },
  //     render: ({ etNft }) => <TreeMintPoolCellPortfolio etNft={etNft} />,
  //   }),
  //   [library]
  // );

  // const memoizedTreeMintPoolCols = useMemo<TableSchema<LandToken>>(
  //   () => ({
  //     id: "eftMintPool",
  //     label: "Mint capacity",
  //     sx: { width: "auto", minWidth: "fit-content", maxWidth: "max-content" },
  //     render: ({ etNft }) => <TreeMintPoolCell etNft={etNft} />,
  //   }),
  //   [library]
  // );

  const actionsColPortfolio: TableSchema<LandToken> = {
    id: "actions",
    label: "Actions",
    style: {
      width: "100px",
    },
    render: (data: LandToken, _index) => {
      const isActive = data.etNft?.easementActivated?.active;
      // Check if the land is expired
      const contractStart = data.etNft?.easementActivated?.contractStart;
      const contractPeriod = data.meta?.contractPeriod;
      const isExpired = contractStart && moment(contractStart).add(contractPeriod, TERM_UNIT).isBefore(moment());
      const total = formatValue(data.etNft?.easementActivated?.treeTotal ?? 0, false);
      const claimed = formatValue(data.etNft?.easementActivated?.rewardClaimed ?? 0, false);
      const text = total && total - claimed > 0 ? "Mint Available" : "Expired";
      let path = "";
      let linkName = "";
      if (
        data.status === EcoTokenStatus.VERIFICATION_REQUIRED ||
        data.status === EcoTokenStatus.CLAIMED ||
        data.status === EcoTokenStatus.RE_VERIFICATION_REQUIRED ||
        data.status === EcoTokenStatus.UPLOADED
      ) {
        path = AppRoutes.LandDetails.path;
        linkName = "Details";
      } else if (data.status === EcoTokenStatus.DRAFT && !data.trust) {
        path = `${AppRoutes.Upload.path}?tokenId=${data.id}`;
        linkName = "Edit";
      } else if (data.status === EcoTokenStatus.VERIFICATION_FAILED || data.status === EcoTokenStatus.DRAFT) {
        path = AppRoutes.LandDetails.path;
        linkName = "Details";
      } else if (!data.etNft || data.etNft.status === "minted") {
        path = AppRoutes.AuctionCreation.path;
        if (!data.etNft) {
          linkName = "Create";
        } else {
          linkName = "Auction";
        }
      } else {
        path = AppRoutes.LandDetails.path;
        linkName = "Details";
      }

      const _path =
        path === AppRoutes.LandDetails.path ? landDetailLink(data.id) : generatePath(path, { tokenId: data.id });
      const detailsPath = landDetailLink(data.id);

      const hasFundsRemaining = text === "Mint Available";

      const isInReverification = data.status === EcoTokenStatus.RE_VERIFICATION_REQUIRED;
      const transferPending = data.etNft?.pendingGuardianUpdate === true;
      console.log({ transferPending });
      console.log({ data });
      return (
        <Row sx={{ gap: 3, alignItems: "center" }}>
          {isActive && !isInReverification && (
            <Tooltip title="Transfer Guardianship">
              <TableActionButton
                size="small"
                disabled={transferPending}
                color="primary"
                variant="contained"
                sx={transferPending ? { textTransform: "none" } : tableActionIconSx}
                onClick={() => handleTransferClick(data)}
              >
                <SwapHorizOutlinedIcon sx={transferPending ? { mr: "4px", fontSize: "1em" } : undefined} />
                {transferPending ? "Pending" : ""}
              </TableActionButton>
            </Tooltip>
          )}
          {(isActive && !isExpired) || (isExpired && hasFundsRemaining) ? (
            <Tooltip title={isExpired ? "Claim remaining funds" : "$TR3 claiming info"}>
              <TableActionButton
                disabled={selectedId !== null && selectedId !== undefined}
                size="small"
                variant="contained"
                sx={tableActionIconSx}
                onClick={() => {
                  setSelectedPortfolioId(data.etNft?.id as number);
                  setSelectedData({
                    name: data.meta?.name,
                    meta: data.meta,
                    etNft: data.etNft,
                    content: data.content,
                    ecoScore: data.ecoScore,
                    targetDate: moment(data?.etNft?.easementActivated?.contractStart)
                      .add(data.meta?.contractPeriod, TERM_UNIT)
                      .toDate(),
                  });
                }}
              >
                <EnergySavingsLeafOutlined />
              </TableActionButton>
            </Tooltip>
          ) : isExpired ? (
            <Link
              to={detailsPath}
              state={{ ref: AppRoutes.Profile.subRoutes.Guarding.path, mode: "mint" }}
              // `display: flex` makes the button a block-level flex item, which unlike an
              // inline-block *does* inherit the anchor's underline — hence textDecoration.
              style={{ display: "flex", textDecoration: "none" }}
            >
              <TableActionButton size="small" color="primary" variant="contained" sx={{ textTransform: "none" }}>
                Details
              </TableActionButton>
            </Link>
          ) : (
            <Link
              to={_path}
              state={{ ref: AppRoutes.Profile.subRoutes.Guarding.path, mode: "mint" }}
              // `display: flex` makes the button a block-level flex item, which unlike an
              // inline-block *does* inherit the anchor's underline — hence textDecoration.
              style={{ display: "flex", textDecoration: "none" }}
            >
              <TableActionButton size="small" color="primary" variant="contained" sx={{ textTransform: "none" }}>
                {linkName}
              </TableActionButton>
            </Link>
          )}
        </Row>
      );
    },
  };

  // const memoizedFundValueCol = useMemo<TableSchema<LandToken>>(
  //   () => ({
  //     id: "value",
  //     label: "Redemable ",
  //     sx: { width: "auto", minWidth: "fit-content", maxWidth: "max-content" },
  //     render: ({ etNft }) => <FundsCell etNft={etNft} library={library} />,
  //   }),
  //   [library]
  // );

  // const memoizedAssetsGuardianStatusCol = useMemo<TableSchema<LandToken>>(
  //   () => ({
  //     id: "guardianStatus",
  //     label: "Status",
  //     render: ({ status, etNft, meta, trust }: LandToken) => (
  //       <MemoizedStatusCell etNft={etNft} status={status} meta={meta} trust={trust} library={library} />
  //     ),
  //   }),
  //   [library]
  // );

  // const memoizedPortfolioGuardianStatusCol = useMemo<TableSchema<LandToken>>(
  //   () => createPortfolioGuardianStatusCol(library),
  //   [library]
  // );

  const responsiveSchemaPort: TableSchema<LandToken>[] = [
    // imgCol,
    // nameCol,
    // memoizedAssetsGuardianStatusCol,
    // memoizedFundValueCol,
    // treeMintPoolCol,
    ...MobileEcoBankLandsSchema,
    actionsColPortfolio,
  ];

  const responsiveSchema: TableSchema<LandToken>[] = [
    // imgCol,
    // nameCol,
    // memoizedPortfolioGuardianStatusCol,
    // treeMintPoolCol,
    ...MobileEcoBankLandsSchema,
    actionSchema,
  ];

  const colSchemaPortfolio: TableSchema<LandToken>[] = [
    // ...baseLandsSchema,
    // scoreCol,
    // ownerCol,
    // memoizedAssetsGuardianStatusCol,
    // memoizedFundValueCol,
    // memoizedTreeMintPoolColsPortfolio,
    ...MobileEcoBankLandsSchema,
    actionsColPortfolio,
  ];

  const colSchema: TableSchema<LandToken>[] = [
    // ...baseLandsSchema,
    // scoreCol,
    // guardianCol,
    // memoizedPortfolioGuardianStatusCol,
    // memoizedTreeMintPoolCols,
    ...MobileEcoBankLandsSchema,
    actionSchema,
  ];

  useEffect(() => {
    console.log({ activeTab });
  }, [activeTab]);
  return (
    <Container tab={activeTab} blogLoading={blogLoading} blogArticles={blogArticles}>
      {(userLoading ||
        loading ||
        (activeTab === "portfolio" && tokensLoading) ||
        (activeTab === "lands" && isLoading)) && (
        // <EmptyBox>
        //     <span>🔎</span>
        //     <span>Data is loading...</span>
        // </EmptyBox>
        <EmptyBoxNew
          sx={{
            backgroundColor: "transparent",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </EmptyBoxNew>
      )}
      <TableWithTabs sx={{ backgroundColor: "back.table", borderRadius: "20px" }}>
        {!(
          userLoading ||
          loading ||
          (activeTab === "portfolio" && tokensLoading) ||
          (activeTab === "lands" && isLoading)
        ) && (
          <TabsRow
            sx={{
              p: "5px 24px 0px 24px",
              borderRadius: "20px 20px 0px 0px",
              marginBottom: !tokenList ? "0px" : 0,
              display: user?.trusteeStatus === "accepted" ? "none" : "block",
              visibility: user?.trusteeStatus === "accepted" ? "hidden" : "visible",
            }}
          >
            <FilterBlock
              sx={{
                "@media (min-width: 600px)": {
                  display: "flex",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  paddingTop: "10px",
                  paddingBottom: "15px",
                },
                "@media (max-width: 599px)": {
                  flexDirection: "row",
                  paddingTop: "10px",
                  paddingBottom: "15px",
                },
              }}
            >
              <Badge badgeContent={actionPendingPortfolio} color="error">
                <ActionBtn
                  className={activeTab === "portfolio" ? "active" : ""}
                  disabled={activeTab === "portfolio"}
                  variant="outlined"
                  size="medium"
                  onClick={() => setActiveTab("portfolio")}
                >
                  Portfolio
                </ActionBtn>
              </Badge>
              <Badge badgeContent={actionPendingAssets} color="error">
                <ActionBtn
                  className={activeTab === "lands" ? "active" : ""}
                  disabled={activeTab === "lands"}
                  variant="outlined"
                  size="medium"
                  onClick={() => setActiveTab("lands")}
                >
                  Assets
                </ActionBtn>
              </Badge>
            </FilterBlock>
          </TabsRow>
        )}

        {(user?.trusteeStatus === "accepted" || user?.trustStatus === "accepted") &&
          !(
            userLoading ||
            loading ||
            (activeTab === "portfolio" && tokensLoading) ||
            (activeTab === "lands" && isLoading)
          ) && (
            <EmptyBoxNew
              sx={{
                marginTop: { xs: "0px", sm: "0px" },
                borderRadius: { xs: "15px", sm: "20px" },
                padding: { xs: "16px", sm: "24px" },
                height: "fit-content",
              }}
            >
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                sx={{
                  width: "100%",
                  alignItems: { xs: "flex-start", md: "flex-start" },
                }}
              >
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: { xs: "6px", sm: "8px", md: "12px" },
                    }}
                  >
                    <Text
                      capital={false}
                      sx={{
                        font: "inherit",
                        fontSize: { xs: "20px", sm: "22px", md: "26px" },
                        fontWeight: "600",
                        color: "black",
                        lineHeight: { xs: 1.3, md: 1.5 },
                      }}
                    >
                      Important
                    </Text>
                    Looks like you accepted to become part of a trust organization
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "stretch", md: "flex-end" },
                    marginTop: { xs: "48px", md: "24px" },
                  }}
                >
                  <Wrapper
                    sx={{
                      width: { xs: "100%", sm: "90%" },
                      p: { xs: 8, sm: 10, md: 12 },
                      backgroundColor: "white",
                      borderColor: "white",
                      marginTop: { xs: 6, sm: 8, md: 10 },
                    }}
                  >
                    <IconContainer>
                      <CircularIcon>
                        <InfoIconOutlined fontSize="large" color="primary" />
                      </CircularIcon>
                    </IconContainer>
                    <InfoBody>
                      <br />
                      <p style={{ fontWeight: 400, color: "black" }}>
                        Why Trustees are not permited to trade EcoFutures?
                      </p>
                      <br />
                      <p style={{ lineHeight: "1.5", color: "GrayText" }}>
                        This is a very short paragraph that introduces the key reasons for EcoFutures Trustee terms and
                        regularions. Text builds trust and understanding.
                      </p>
                      <br />
                      <a href={AppRoutes.About.path} target="_blank" rel="noopener noreferrer">
                        Read More
                      </a>
                    </InfoBody>
                  </Wrapper>
                </Grid>
              </Grid>
            </EmptyBoxNew>
          )}
        {activeTab === "portfolio" && !(user?.trusteeStatus === "accepted" || user?.trustStatus === "accepted") && (
          <>
            {!landsBought && !(userLoading || loading || tokensLoading) ? (
              <EmptyBoxNew
                sx={{
                  marginTop: { xs: "0px", sm: "0px" },
                  borderRadius: { xs: "15px", sm: "20px" },
                  padding: { xs: "16px", sm: "24px" },
                  height: "fit-content",
                  minHeight: "320px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: 2 }}>
                  <InfoIconOutlined sx={{ fontSize: "32px", color: "black" }} />
                  <Box sx={{ fontSize: { xs: "14px", sm: "16px" }, color: "black" }}>
                    Looks like you have no EFTs in your portfolio.
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", md: "flex-start" },
                    width: "100%",
                    marginTop: { xs: "4px", sm: "8px", md: "16px" },
                    borderTop: "1px solid black",
                    padding: { xs: "18px 0px", sm: "26px 0px", md: "20px 20px 0px 0px" },
                    gap: "20px",
                  }}
                >
                  <Box sx={{ fontWeight: "bold", marginRight: 1, fontSize: { xs: "14px", sm: "16px" } }}>
                    Would you like to explore available EFTs?
                  </Box>
                  <IconButton
                    onClick={() => navigator(AppRoutes.Explore.path)}
                    sx={{
                      padding: "10px",
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <LanguageIcon sx={{ color: "black" }} />
                  </IconButton>
                </Box>
              </EmptyBoxNew>
            ) : (
              <>
                <div style={{ display: userLoading || loading || tokensLoading ? "none" : "block", width: "100%" }}>
                  {isGuardian ? (
                    <TableComponent
                      mobileTitle=""
                      batch={5}
                      hideTitle={true}
                      totalItems={landsBought}
                      title="Bought assets"
                      customData={getCachedData("boughtLands") || []}
                      apiURL=""
                      schema={isMobile ? responsiveSchema : colSchema}
                    />
                  ) : (
                    <TableComponent
                      mobileTitle=""
                      batch={5}
                      hideTitle={true}
                      totalItems={landsBought}
                      title="Bought assets"
                      customData={getCachedData("boughtLands") || []}
                      apiURL=""
                      schema={isMobile ? responsiveSchema : colSchema}
                    />
                  )}
                </div>
              </>
            )}
          </>
        )}

        {activeTab === "lands" && !(user?.trusteeStatus === "accepted" || user?.trustStatus === "accepted") && (
          <>
            {!tokensLoading && !tokens && !(userLoading || loading || isLoading) && (
              <EmptyBoxNew
                sx={{
                  marginTop: { xs: "0px", sm: "0px" },
                  borderRadius: { xs: "15px", sm: "20px" },
                  padding: { xs: "16px", sm: "24px" },
                  height: "fit-content",
                  minHeight: "320px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: 2 }}>
                  <InfoIconOutlined sx={{ fontSize: "32px", color: "black" }} />
                  <Box sx={{ fontSize: { xs: "14px", sm: "16px" }, color: "black" }}>
                    Looks like you haven't uploaded any land yet. In order to upload a land you will need a referral
                    code from another Guardian account.
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", md: "flex-start" },
                    width: "100%",
                    marginTop: { xs: "4px", sm: "8px", md: "16px" },
                    borderTop: "1px solid black",
                    padding: { xs: "18px 0px", sm: "26px 0px", md: "20px 20px 0px 0px" },
                    gap: "20px",
                  }}
                >
                  <Box sx={{ fontWeight: "bold", marginRight: 1, fontSize: { xs: "14px", sm: "16px" } }}>
                    {text}
                    {/* <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          flexWrap: "wrap",
                        }}
                      >
                        <a href={link} style={{ color: "inherit", textDecoration: "underline" }}>Here's</a> our in-depth story covering this process step by step.
                      </div> */}
                  </Box>
                  <IconButton
                    onClick={() => navigator(link)}
                    sx={{
                      padding: "10px",
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    {canMint ? <AddIcon sx={{ color: "black" }} /> : <PasswordIcon sx={{ color: "black" }} />}
                  </IconButton>
                </Box>
              </EmptyBoxNew>
            )}
            <div style={{ display: isLoading || (!tokensLoading && !tokens) ? "none" : "block", width: "100%" }}>
              <TableComponent
                mobileTitle=""
                setLoading={setIsLoading}
                batch={5}
                schema={isMobile ? responsiveSchemaPort : colSchemaPortfolio}
                customData={getCachedData("profileTokens") || []}
                apiURL=""
                title={""}
                hideTitle={true}
                totalItems={tokens}
              />
            </div>

            {selectedPortfolioId !== null && selectedPortfolioId !== undefined && (
              <TreeClaimModalNew
                token={selectedData}
                guardian={true}
                id={selectedPortfolioId}
                setId={setSelectedPortfolioId}
                name={selectedData.name}
                content={selectedData.content}
                refresh={handleClaimRefresh}
                targetDate={selectedData.targetDate}
              />
            )}
          </>
        )}

        {selectedId !== null && selectedId !== undefined && (
          <TreeClaimModalNew
            guardian={false}
            token={selectedData}
            id={selectedId}
            setId={setSelectedId}
            name={selectedData.name}
            content={selectedData.content}
            refresh={handleClaimRefresh}
            targetDate={selectedData.targetDate}
          />
        )}

        {selectedOfferToken && (
          <OfferCreationModal
            token={selectedOfferToken}
            open={offerCreationModalOpen}
            setOpen={setOfferCreationModalOpen}
            onSuccess={() => {
              handleListingSuccess();
            }}
          />
        )}

        {selectedCancelToken && (
          <OfferCancellationModal
            token={selectedCancelToken}
            open={cancelOfferModalOpen}
            setOpen={(open) => {
              setCancelOfferModalOpen(open);
              if (!open) setSelectedCancelToken(null);
            }}
            onSuccess={() => {
              handleListingCancelSuccess();
            }}
          />
        )}

        <LandTransferModal
          open={isTransferring}
          onClose={() => handleTransferModalClose()}
          onConfirm={(newGuardianAddress) => handleTransferConfirm(newGuardianAddress)}
          loading={transferLoading}
          error={transferError}
          land={selectedTransferLand || null}
        />
      </TableWithTabs>
    </Container>
  );
};

const Container = ({
  children,
  tab,
  blogLoading,
  blogArticles,
}: {
  children: any;
  tab: "lands" | "portfolio";
  blogLoading: boolean;
  blogArticles: { [key: string]: any };
}) => (
  <Profile surface="beige" panel={children}>
    <Grid width="100%" flexDirection="column" display="flex">
      {tab === "portfolio" ? (
        <Trending
          sx={{
            position: "relative",
            borderRadius: "20px 20px 20px 20px",
            border: "none",
          }}
        >
          {!blogLoading && blogArticles["2"] && (
            <>
              <img
                src={blogArticles["2"].image}
                alt="Blog article"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  filter: "brightness(1)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(to right, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)",
                  zIndex: 1,
                }}
              />
              <BlogStoryBlock
                blog={blogArticles["2"]}
                sx={{ zIndex: 2 }}
                search={blogArticles["2"].Slug}
                subtitle={blogArticles["2"].subtitle}
                paragraph={blogArticles["2"].paragraph}
              />
            </>
          )}
        </Trending>
      ) : (
        <Trending
          sx={{
            position: "relative",
            borderRadius: "20px 20px 20px 20px",
            border: "none",
          }}
        >
          {!blogLoading && blogArticles["3"] && (
            <>
              <img
                src={blogArticles["3"].image}
                alt="Blog article"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  filter: "brightness(1)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(to right, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)",
                  zIndex: 1,
                }}
              />
              <BlogStoryBlock
                blog={blogArticles["3"]}
                sx={{ zIndex: 2 }}
                search={blogArticles["3"].Slug}
                subtitle={blogArticles["3"].subtitle}
                paragraph={blogArticles["3"].paragraph}
              />
            </>
          )}
        </Trending>
      )}
    </Grid>
  </Profile>
);

// Every button in an Actions column takes one fixed height, so a cell that mixes text and
// icon-only buttons lines them up instead of letting each one's content set its size. The
// padding here is inner padding, horizontal only — the height is already fixed.
const TABLE_ACTION_HEIGHT = "36px";

const TableActionButton = styled(Button)({
  height: TABLE_ACTION_HEIGHT,
  minHeight: TABLE_ACTION_HEIGHT,
  padding: "0 16px",
  whiteSpace: "nowrap",
  backgroundColor: "black",
  color: "white",
  fontFamily: "'Inter', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  border: "none",
  "&:hover": {
    backgroundColor: "#333",
    border: "none",
    color: "white",
  },
  "&.Mui-disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    color: "rgba(255, 255, 255, 0.6)",
  },
});

// Icon-only actions: same height, tighter inner padding so the button stays near-square.
// `minWidth: "unset"` overrides MUI's 64px Button minimum, which would stretch it to a slab.
const tableActionIconSx = { minWidth: "unset", padding: "0 8px" };

export const Trending = styled("div")`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(69vw - 0px);
  max-height: 600px;
  overflow: hidden;
  -webkit-transform: translateZ(0);

  @media (max-width: 600px) {
    height: calc(100vw - 0px);
    max-height: 400px;
  }

  & > img {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    margin: 0;
    padding: 0;
  }
`;
export const FilterBlock = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  overflow-x: auto;
  white-space: nowrap;

  /* The strip scrolls horizontally once the tabs outgrow the bar. The Figma has
     no scrollbar, and a classic one both contradicts it and eats 3px of the
     72px bar; scrolling itself (swipe, drag, keyboard focus) is unaffected. */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 600px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding-bottom: 8px;
  }
  & button {
    border: 1px solid
      ${({ theme }) => (theme.palette.mode === "dark" ? theme.palette.border.default : theme.palette.border.default)};
    border-radius: 15px;
    text-transform: capitalize;
    padding: 6px 16px;
    transition: none;
    box-sizing: border-box;

    @media (max-width: 600px) {
      /* Holds the Figma's 42px pill (and a comfortable tap target) at the
         smaller mobile type size — 4px of padding left them only 34px tall. */
      padding: 8px 14px;
      font-size: 0.875rem;
    }

    &:hover {
      animation: none;
      transform: none;
      transition: none;
      border: 1px solid
        ${({ theme }) => (theme.palette.mode === "dark" ? theme.palette.border.default : theme.palette.border.default)};
      width: auto;
      height: auto;
      box-sizing: border-box;
    }

    &.active {
      border: 1px solid transparent;
    }

    &:disabled {
      background-color: ${({ theme }) => theme.palette.border.default};
      color: ${({ theme }) => theme.palette.text.primary};
      pointer-events: none;
    }
  }
`;

export default GuardianPortal;
